module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2r1r4r8r-038de231fff5462e139ec55a25645e04.svg";